import React, { useState, useEffect, useRef } from 'react';
import { TrendingUp, Award, Building2, DollarSign, Lightbulb, Users, Target, Briefcase, FileText, CheckCircle, Star } from 'lucide-react';

function Team() {
  const [isVisible, setIsVisible] = useState(false);
  const [animatedValues, setAnimatedValues] = useState({});
  const sectionRef = useRef(null);

  const countdata = [
    { ct: 70, title: 'Startups raised external fundings', icon: TrendingUp, color: 'from-emerald-500 to-teal-600' },
    { ct: 7, title: 'Total CSR fundings (Cr)', icon: DollarSign, color: 'from-blue-500 to-cyan-600' },
    { ct: 250, title: 'Total number of startups incubated', icon: Building2, color: 'from-purple-500 to-indigo-600' },
    { ct: 300, title: 'Quantum of external funding raised by startups (Cr)', icon: Award, color: 'from-orange-500 to-red-600' },
    { ct: 60, title: 'Startups supported through Seed Support', icon: Lightbulb, color: 'from-yellow-500 to-orange-600' },
    { ct: 40, title: 'Graduated Startups', icon: Users, color: 'from-green-500 to-emerald-600' },
    { ct: 150, title: 'Active startups', icon: Target, color: 'from-pink-500 to-rose-600' },
    { ct: 800, title: 'Total valuation of the incubated startups (Cr)', icon: Briefcase, color: 'from-violet-500 to-purple-600' },
    { ct: 9, title: 'Published IP', icon: FileText, color: 'from-indigo-500 to-blue-600' },
    { ct: 7, title: 'Granted IP', icon: CheckCircle, color: 'from-teal-500 to-cyan-600' },
    { ct: 25, title: 'Filed IP', icon: Star, color: 'from-amber-500 to-yellow-600' },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    countdata.forEach((item, index) => {
      const duration = 2000;
      const steps = 60;
      const increment = item.ct / steps;
      let current = 0;

      const timer = setInterval(() => {
        current += increment;
        if (current >= item.ct) {
          current = item.ct;
          clearInterval(timer);
        }
        setAnimatedValues(prev => ({ ...prev, [index]: Math.floor(current) }));
      }, duration / steps);

      return () => clearInterval(timer);
    });
  }, [isVisible]);

  return (
    <div className="min-h-screen border-b border-gray-700 bg-gradient-to-br pt-10 from-slate-50 via-blue-50 to-indigo-100">
      <div ref={sectionRef} className="px-6 pb-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="text-4xl flex gap-2 justify-center md:text-5xl font-bold text-gray-800 mb-4">
              <div className='text-blue-600'>Our</div> <div>Achievements</div>
            </div>
            {/* <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Empowering innovation and fostering entrepreneurship through our comprehensive incubation program
            </p> */}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {countdata.map((data, idx) => {
              const IconComponent = data.icon;
              const animatedValue = animatedValues[idx] || 0;

              return (
                <div
                  key={idx}
                  className={`group relative overflow-hidden rounded-2xl bg-white shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 ${
                    isVisible ? 'animate-fade-in-up' : 'opacity-0'
                  }`}
                  style={{
                    animationDelay: `${idx * 100}ms`,
                    animationFillMode: 'forwards'
                  }}
                >
                  <div className={`absolute inset-0 bg-gradient-to-br ${data.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>
                  
                  <div className="relative p-6">
                    <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br ${data.color} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                      <IconComponent className="w-6 h-6 text-white" />
                    </div>

                    <div className="mb-3">
                      <span className="text-3xl md:text-4xl font-bold text-gray-800 tabular-nums">
                        {animatedValue}
                        {data.title.includes('Cr') && animatedValue > 0 && (
                          <span className="text-lg ml-1">Cr</span>
                        )}
                      </span>
                    </div>

                    <p className="text-sm md:text-base text-gray-600 font-medium leading-relaxed">
                      {data.title.replace(' (Cr)', '')}
                    </p>

                    <div className={`absolute bottom-0 left-0 h-1 bg-gradient-to-r ${data.color} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left`}></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/5 to-purple-600/5"></div>
        <div className="relative py-12 text-center">
          <div className="flex justify-center space-x-2 mb-4">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className={`w-2 h-2 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 animate-pulse`}
                style={{ animationDelay: `${i * 200}ms` }}
              ></div>
            ))}
          </div>
          <p className="text-gray-600 font-medium">
            Building the future, one startup at a time
          </p>
        </div>
      </div> */}
    </div>
  );
}

export default Team;
